
export default {
  "hash": "4c7938b"
};
